import React from 'react';
import { motion } from 'framer-motion';
import { MenuItemCard } from './MenuItemCard';

const CATEGORY_TRANSITION = { duration: 0.5 };
const CONTAINER_VARIANTS = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { staggerChildren: 0.08 } },
};

const getLocalizedText = (value, language) =>
  typeof value === 'string' ? value : value[language];

export const CategorySection = ({ category, language, onAddToCart, translations: t }) => {
  const subtitle = category.subtitle ? getLocalizedText(category.subtitle, language) : null;

  return (
    <motion.div
      key={category.id}
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={CATEGORY_TRANSITION}
      data-testid={`category-section-${category.id}`}
    >
      <div className="flex items-end justify-between gap-4 mb-6">
        <div>
          <h2 className="text-2xl md:text-3xl font-bold tracking-tight">
            {category.title[language]}
          </h2>
          {subtitle && <p className="mt-2 text-sm text-muted-foreground">{subtitle}</p>}
        </div>
        <div className="text-sm text-muted-foreground">
          {category.items.length} {t.options}
        </div>
      </div>
      <motion.div
        variants={CONTAINER_VARIANTS}
        initial="hidden"
        animate="visible"
        className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6"
      >
        {category.items.map((item, index) => (
          <MenuItemCard
            key={`${category.id}-${index}`}
            item={item}
            category={category}
            index={index}
            language={language}
            onAddToCart={onAddToCart}
            translations={t}
          />
        ))}
      </motion.div>
    </motion.div>
  );
};
